import urls from "../helpers/url_helpers";
import { post, get, SSO_API_URL } from "../helpers/api_helpers";
import store from "../store";
import cookieUtils from "../utils/Cookies";
import { handleRouting } from "@/utils/constants";

//Authentication
export async function loginUser(user, config = {}) {
  return await post(urls.LOGIN_USER, user, config, SSO_API_URL);
}

export async function loginUser2FA(user, config = {}) {
  return await post(urls.LOGIN_USER_2FA, user, config, SSO_API_URL);
}

export async function signUpLocal(user, config = {}) {
  return await post(urls.SIGN_UP_WITH_MATTA, user, config);
}
export async function getTokenInfo(config = {}) {
  return await post(
    `${urls.GET_TOKEN_INFORMATION}/${process.env.VUE_APP_OXIDE_APP_CODE}`,
    {},
    config,
    SSO_API_URL
  );
}

export async function logOut() {
  await cookieUtils.removeAll();
  store.commit("clearUserData");
  localStorage.clear();
  handleRouting();
}
export async function registerUser(user, config = {}) {
  return await post(urls.REGISTER, user, config);
}
export async function resend2FA(data, config = {}) {
  return await post(urls.RESEND_2FA_OTP, data, config);
}
export async function registerInvitedUser(user, config = {}) {
  return await post(urls.REGISTER_INVITED_USER, user, config);
}
export async function forgotPassword(user, config = {}) {
  return await post(urls.FORGOT_PASSWORD, user, config);
}
export async function resendVerification(data, config = {}) {
  return await post(urls.RESEND_VERIFICATION, data, config);
}

export async function resetPassword(user, config = {}) {
  return await post(urls.RESET_PASSWORD, user, config);
}

export async function confirmemail({ userId, code }, config = {}) {
  return await get(
    `${urls.CONFIRM_EMAIL}?userId=${userId}&code=${code}`,
    config
  );
}
export async function socialregister(data) {
  return await post(urls.SOCIAL_REGISTER, data);
}

export async function sociallogin(data) {
  return await post(urls.SOCIAL_LOGIN, data);
}

export async function retriveToken(data, config = {}) {
  return await post(urls.RETRIVE_TOKEN, data, config, SSO_API_URL);
}
